// extracted by mini-css-extract-plugin
module.exports = {"bylineContainer":"styles-module__bylineContainer___22ZPJ","byline":"styles-module__byline___2KW7T","bylineWrapper":"styles-module__bylineWrapper___3Y7mY"};